module.exports = __webpack_public_path__ + "static/media/galerija_2021 (1)-min.ca2abf6c.jpg";